/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.DefLoan.Title',
    defaultMessage: 'Deferred Loan',
  },
});

export default messages;
